var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8650"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8309",
    style: {
      fill: "#fff"
    },
    d: "M0 0h64v64H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-331.402 -217)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 5707",
    width: 14.931,
    height: 2.703,
    rx: 1.351,
    transform: "translate(335.223 231.655)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40872",
    d: "M362.757 251.364a.472.472 0 0 0 .087-.012.523.523 0 0 0 .426-.459v-1.712a.523.523 0 0 0-.174-.373.507.507 0 0 0-.2-.1.8.8 0 0 0-.235-.016h-1.617l-12.144.008a.489.489 0 0 0-.361.159.5.5 0 0 0-.126.375v1.527a.73.73 0 0 0 .017.2.492.492 0 0 0 .417.358h3.43l5.459.01 3.681.014 1 .009-1 .009-3.681.014-5.459.01h-3.453a.594.594 0 0 1-.216-.07.577.577 0 0 1-.276-.349.706.706 0 0 1-.021-.223v-1.52a.6.6 0 0 1 .152-.436.572.572 0 0 1 .427-.188l12.145.014h1.617a1 1 0 0 1 .25.021.551.551 0 0 1 .216.115.561.561 0 0 1 .194.41v1.141c0 .218 0 .408-.009.579a.551.551 0 0 1-.211.365.524.524 0 0 1-.241.1.311.311 0 0 1-.094.02z",
    transform: "translate(-13.133 -17.006)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 373",
    cx: 7.134,
    cy: 7.134,
    r: 7.134,
    transform: "rotate(-2.75 5501.22 -7777.1)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40873",
    d: "M604.076 420.84v.019a7.134 7.134 0 1 0 14.267.206v-.019z",
    transform: "translate(-224.274 -159.195)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40874",
    d: "M616.247 397.763a5.009 5.009 0 1 0 5.081-4.936 5.009 5.009 0 0 0-5.081 4.936z",
    transform: "translate(-234.322 -136.069)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40875",
    d: "M621.331 392.828a5.009 5.009 0 0 0-5.081 4.936l10.017.145a5.009 5.009 0 0 0-4.936-5.081z",
    transform: "translate(-234.324 -136.069)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40876",
    d: "M627.468 407.055a3.052 3.052 0 1 0 3.1-3.006 3.052 3.052 0 0 0-3.1 3.006z",
    transform: "translate(-243.585 -145.333)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40877",
    d: "M602.08 360.243s7.3-2.209 10.323 5.726L597.12 370.7z",
    transform: "translate(-218.532 -108.937)",
    style: {
      fill: "#00c9a6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 374",
    cx: 7.134,
    cy: 7.134,
    r: 7.134,
    transform: "rotate(-2.75 5479.232 -6860.21)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40878",
    d: "M351.786 420.84v.019a7.134 7.134 0 1 0 14.267.206v-.023z",
    transform: "translate(-16.002 -159.195)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40879",
    d: "M364 397.763a5.009 5.009 0 1 0 5.081-4.936 5.009 5.009 0 0 0-5.081 4.936z",
    transform: "translate(-26.082 -136.069)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40880",
    d: "M369.074 392.828a5.009 5.009 0 0 0-5.074 4.936l10.017.145a5.009 5.009 0 0 0-4.943-5.081z",
    transform: "translate(-26.085 -136.07)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40881",
    d: "M375.178 407.055a3.052 3.052 0 1 0 3.1-3.006 3.052 3.052 0 0 0-3.1 3.006z",
    transform: "translate(-35.313 -145.333)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40882",
    d: "M393.174 402.4c-.04.021-3.755-.574-3.755-.574a2.268 2.268 0 0 1-1.694.886c-1.605.077-3.174.148-4.536.209a2.3 2.3 0 0 0-2.2 2.4 2.3 2.3 0 0 0 2.211 2.205l7.909.312a5.277 5.277 0 0 0 3.838-1.755z",
    transform: "translate(-40.11 -143.501)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40883",
    d: "M339.566 297.637s-.338-6.953 6.2-8.4v-.892h22.887v2.139s-3.359 4.046-2.268 7.4 1.439 3.7 1.439 3.7h13.026a8.9 8.9 0 0 0 1.645-4.936c.07-2.949-1.155-7.989-2.071-11.212-.827-2.94-1.35-5.389-1.35-5.389l3.908-1.3s7.232 9.465 7.527 9.989a6.438 6.438 0 0 1 1.064 4.491c-.236 2.718-6.742 11.1-8.448 12.049a12.721 12.721 0 0 1-4.786 1.24c-1.333.206-11.194.07-13.775.03a5.06 5.06 0 0 1-2.547-.707 5.722 5.722 0 0 1-1.991-2.512l-1.366-2.659z",
    transform: "translate(-5.911 -41.896)",
    style: {
      fill: "#00c9a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40884",
    d: "m335.406 384.26-2.882 4.515a.7.7 0 0 0 .857 1.033 3.358 3.358 0 0 0 .968-.656 44.852 44.852 0 0 0 3.664-4.559z",
    transform: "translate(0 -128.997)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40885",
    d: "M374.71 351.671a.2.2 0 0 1 .017-.066l.058-.19a5.015 5.015 0 0 0 .152-.745 5.259 5.259 0 0 0-.447-2.725 5.709 5.709 0 0 0-1.063-1.6 6.972 6.972 0 0 0-1.745-1.337 8.833 8.833 0 0 0-2.286-.851 12.037 12.037 0 0 0-2.617-.271 19.725 19.725 0 0 0-2.617.194c-.844.113-1.654.253-2.418.427a14.321 14.321 0 0 0-3.882 1.436 9.606 9.606 0 0 0-2.218 1.694c-.23.237-.4.435-.506.569l-.124.155a.311.311 0 0 1-.045.051 5.862 5.862 0 0 1 .649-.8 9.424 9.424 0 0 1 2.212-1.726 14.2 14.2 0 0 1 3.9-1.462c.764-.175 1.57-.319 2.423-.434a19.855 19.855 0 0 1 2.638-.2 12.007 12.007 0 0 1 2.631.274 8.938 8.938 0 0 1 2.307.872 7.012 7.012 0 0 1 1.767 1.357 5.744 5.744 0 0 1 1.066 1.623 5.235 5.235 0 0 1 .422 2.757 4.449 4.449 0 0 1-.174.745l-.066.188a.355.355 0 0 1-.034.065z",
    transform: "translate(-18.63 -95.595)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40886",
    d: "M436.4 356.879c-.01 0 .037-.11.085-.309a2.256 2.256 0 0 0 .026-.872 3.586 3.586 0 0 0-.426-1.211 4.142 4.142 0 0 0-.422-.635 3.828 3.828 0 0 0-.567-.588 4.952 4.952 0 0 0-1.361-.8 6.405 6.405 0 0 0-1.249-.349 8.167 8.167 0 0 0-.872-.1 2.567 2.567 0 0 1-.321-.024.279.279 0 0 1 .084 0h.239a6.517 6.517 0 0 1 .872.072 6.03 6.03 0 0 1 1.27.326 4.972 4.972 0 0 1 1.4.8 4 4 0 0 1 .579.6 4.358 4.358 0 0 1 .424.651 3.472 3.472 0 0 1 .415 1.242 2.15 2.15 0 0 1-.054.883 1.258 1.258 0 0 1-.084.225.307.307 0 0 1-.038.089z",
    transform: "translate(-81.635 -102.359)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5967",
    style: {
      opacity: 0.4
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40887",
    d: "M350.28 248.424a9.166 9.166 0 0 1 3.446 1.4 6.091 6.091 0 0 1 2.308 2.868 5.031 5.031 0 0 1-.092 3.708l1.617.134a5.939 5.939 0 0 0-1.356-5.466 8.026 8.026 0 0 0-5.923-2.647"
  }))), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 5708",
    width: 17.142,
    height: 17.192,
    rx: 2,
    transform: "translate(334.119 229.262)",
    style: {
      fill: "#0254a3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40888",
    d: "M359.035 279.085c0 .026-3.854.045-8.607.045s-8.608-.019-8.608-.045 3.852-.045 8.608-.045 8.607.021 8.607.045z",
    transform: "translate(-7.775 -42.135)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40889",
    d: "M397.488 338.2c0 .024-5.145.045-11.489.045s-11.489-.021-11.489-.045 5.143-.045 11.489-.045 11.489.016 11.489.045z",
    transform: "translate(-34.761 -90.932)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40890",
    d: "M455.863 322.8a1.978 1.978 0 0 0 .415-1.026c.035-.574-.227-1.293-.846-1.293h-7.9a2.319 2.319 0 0 0-2.319 2.319z",
    transform: "translate(-93.126 -76.345)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40891",
    d: "m558.72 249.517-1.375-2.867a1.745 1.745 0 0 1 .7-2.242l4.111-2.451a1.378 1.378 0 0 1 .71-.2h.888l.349 5.794-1.368.529.872 1.41z",
    transform: "translate(-185.562 -11.359)",
    style: {
      fill: "#00c9a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40892",
    d: "M594.91 243s1.406.323 1.582 2.49a2.741 2.741 0 0 1-1.24 2.844z",
    transform: "translate(-216.707 -12.383)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40893",
    d: "M552.09 262.3s-2.842 1.347-3.189 1.57a.662.662 0 0 0-.258.9c.321.8 1.651.047 1.651.047l2.647-1.323s1.017-.48.64-1.082c-.422-.678-1.491-.112-1.491-.112z",
    transform: "translate(-178.452 -28.132)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40895",
    d: "M559.029 229.958c0 1.082-.5 1.958-1.11 1.958s-1.11-.872-1.11-1.958.5-1.958 1.11-1.958 1.11.872 1.11 1.958z",
    transform: "translate(-185.255)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40896",
    d: "m564.21 245.085.611 2.115a.548.548 0 0 0 .284-.625c-.154-.724-.241-1.239-.408-1.874-.021-.063-.487.384-.487.384",
    transform: "translate(-191.364 -13.782)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5968",
    style: {
      opacity: 0.4
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40897",
    d: "M360.771 256.888c-.059-.174-.122-.349-.174-.536s-.119-.349-.164-.523a5.628 5.628 0 0 1-.154-.8c-1.029 4.187.543 7.141 3.24 7.349 3.943.3 8.75.523 10.693.014a8.267 8.267 0 0 0 5.154-4.372c.311-.487 3.128-5.639 1.4-10.6a72.738 72.738 0 0 0-4.737-10.228l-2.867.963s.523 2.443 1.356 5.381c.916 3.223 2.141 8.263 2.071 11.212a8.9 8.9 0 0 1-1.645 4.936h-13.028a11.266 11.266 0 0 1-1.139-2.792"
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40898",
    d: "m336.57 376.075.093-.994 23.777 2.739a2.348 2.348 0 0 1 2.038 2.743l-.106.6-24.6-3.575a1.4 1.4 0 0 1-1.202-1.513z",
    transform: "translate(-3.436 -121.419)",
    style: {
      fill: "#ff725e"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5969",
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40899",
    d: "m336.57 376.075.093-.994 23.777 2.739a2.348 2.348 0 0 1 2.038 2.743l-.106.6-24.6-3.575a1.4 1.4 0 0 1-1.202-1.513z",
    transform: "translate(-3.436 -121.419)",
    style: {
      fill: "#007863"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5970",
    style: {
      opacity: 0.36
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40900",
    d: "M379.366 261.307s5.234-5.758 6.314-10.283a10.177 10.177 0 0 1 1.621.12s-3.095 8.414-7.935 10.163z"
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40901",
    d: "M606.538 348.34a.842.842 0 0 1 .028.145c.014.1.042.237.059.421a6.408 6.408 0 0 1-.04 1.57 7.934 7.934 0 0 1-.7 2.212 25.072 25.072 0 0 1-1.385 2.478 33.092 33.092 0 0 1-3.064 4.142c-.426.5-.778.906-1.022 1.181l-.283.316a1.2 1.2 0 0 1-.1.106.779.779 0 0 1 .089-.117l.27-.328 1-1.2a35.969 35.969 0 0 0 3.036-4.149 26.562 26.562 0 0 0 1.4-2.465 8.1 8.1 0 0 0 .7-2.188 6.982 6.982 0 0 0 .068-1.549c-.012-.183-.035-.325-.042-.422a.764.764 0 0 1-.014-.153z",
    transform: "translate(-220.934 -99.344)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40902",
    d: "M577.834 411.189a6.994 6.994 0 0 1-.839-.757 7.173 7.173 0 0 1-.775-.822 13.992 13.992 0 0 1 1.614 1.579z",
    transform: "translate(-201.278 -149.924)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40903",
    d: "M496.43 411.128a2.423 2.423 0 0 1 .386-.745 2.455 2.455 0 0 1 .55-.633c.019.019-.22.305-.475.684s-.437.705-.461.694z",
    transform: "translate(-135.41 -150.04)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40904",
    d: "M427 411.588a3.512 3.512 0 0 0 .714-.907 3.122 3.122 0 0 0 .349-1.2 2.776 2.776 0 0 0-1.253-2.617 3.117 3.117 0 0 0-1.148-.48 3.509 3.509 0 0 0-1.153-.016.335.335 0 0 1 .077-.023 1.91 1.91 0 0 1 .23-.045 2.739 2.739 0 0 1 .858.021 3.121 3.121 0 0 1 1.183.473 2.82 2.82 0 0 1 1.289 2.7 3.123 3.123 0 0 1-.377 1.221 2.706 2.706 0 0 1-.523.68 1.783 1.783 0 0 1-.174.152.323.323 0 0 1-.072.041z",
    transform: "translate(-76.038 -147.176)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40905",
    d: "M388.489 418.292a3.748 3.748 0 0 1-.086-.838 3.961 3.961 0 0 1 0-.844 7.83 7.83 0 0 1 .08 1.682z",
    transform: "translate(-46.212 -155.703)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40906",
    d: "M391.625 418.285a8.083 8.083 0 0 1-.215-1.685 4.107 4.107 0 0 1 .152.838 4.066 4.066 0 0 1 .063.847z",
    transform: "translate(-48.713 -155.694)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40907",
    d: "M387.761 333.555c0 .024-2.891.045-6.455.045s-6.455-.021-6.455-.045 2.891-.045 6.455-.045 6.455.019 6.455.045z",
    transform: "translate(-35.042 -87.101)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40908",
    d: "M394.975 263.781c-.026 0-.045-3.315-.045-7.394s.012-7.387.045-7.387.045 3.315.045 7.4-.02 7.381-.045 7.381z",
    transform: "translate(-51.618 -17.336)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40909",
    d: "M384.986 263.728c-.024 0 .1-3.315.277-7.391s.349-7.389.366-7.387-.1 3.315-.276 7.391-.334 7.389-.367 7.387z",
    transform: "translate(-43.406 -17.295)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40910",
    d: "M353.2 403.192a.572.572 0 0 1-.077-.078c-.045-.052-.12-.127-.2-.234a6.7 6.7 0 0 1-.644-.946 7.228 7.228 0 0 1 .03-7.237 6.57 6.57 0 0 1 .651-.94c.084-.107.159-.175.206-.234s.075-.078.077-.075a.437.437 0 0 1-.063.087c-.042.058-.113.134-.192.244a7.468 7.468 0 0 0-.037 9.078c.077.11.147.188.188.246s.061.086.061.089z",
    transform: "translate(-15.617 -136.582)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2506",
    d: "M417.462 163a1.462 1.462 0 0 1 1.462 1.462 1.462 1.462 0 0 1-1.462 1.462 1.462 1.462 0 0 1-1.462-1.462 1.462 1.462 0 0 1 1.462-1.462z",
    transform: "translate(-78.491 76.643)",
    style: {
      fill: "#00de9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2507",
    d: "M417.462 108a1.462 1.462 0 0 1 1.462 1.462 1.462 1.462 0 0 1-1.462 1.462 1.462 1.462 0 0 1-1.462-1.462 1.462 1.462 0 0 1 1.462-1.462z",
    transform: "translate(-78.491 127.814)",
    style: {
      fill: "#00de9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2508",
    d: "M417.462 53a1.462 1.462 0 0 1 1.462 1.462 1.462 1.462 0 0 1-1.462 1.462A1.462 1.462 0 0 1 416 54.462 1.462 1.462 0 0 1 417.462 53z",
    transform: "translate(-78.491 178.986)",
    style: {
      fill: "#00de9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2509",
    d: "M472.462 163a1.462 1.462 0 0 1 1.462 1.462 1.462 1.462 0 0 1-1.462 1.462 1.462 1.462 0 0 1-1.462-1.462 1.462 1.462 0 0 1 1.462-1.462z",
    transform: "translate(-129.663 76.643)",
    style: {
      fill: "#00de9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2510",
    d: "M472.462 108a1.462 1.462 0 0 1 1.462 1.462 1.462 1.462 0 0 1-1.462 1.462 1.462 1.462 0 0 1-1.462-1.462 1.462 1.462 0 0 1 1.462-1.462z",
    transform: "translate(-129.663 127.814)",
    style: {
      fill: "#00de9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2511",
    d: "M472.462 53a1.462 1.462 0 0 1 1.462 1.462 1.462 1.462 0 0 1-1.462 1.462A1.462 1.462 0 0 1 471 54.462 1.462 1.462 0 0 1 472.462 53z",
    transform: "translate(-129.663 178.986)",
    style: {
      fill: "#00de9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2512",
    d: "M527.462 108a1.462 1.462 0 0 1 1.462 1.462 1.462 1.462 0 0 1-1.462 1.462 1.462 1.462 0 0 1-1.462-1.462 1.462 1.462 0 0 1 1.462-1.462z",
    transform: "translate(-180.834 127.814)",
    style: {
      fill: "#00de9d"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBike);
export default __webpack_public_path__ + "static/media/bike.6a7c815437964cfd06f6895c2583ae0b.svg";
export { ForwardRef as ReactComponent };